module.exports = __webpack_public_path__ + "img/homeSliderGraphic.78b8c4d9.png";